import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMacbook: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconMacbook"><Path d="M22.5 18C22.7761 18 23 18.2239 23 18.5C23 19.8807 21.8807 21 20.5 21H3.5C2.11929 21 1 19.8807 1 18.5C1 18.2239 1.22386 18 1.5 18H22.5Z" fill="currentColor"/><Path d="M18.5 3C19.8807 3 21 4.11929 21 5.5V17H3V5.5C3 4.11929 4.11929 3 5.5 3H18.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMacbook;
